import React from 'react';
import {FormattedMessage} from 'react-intl';
import {connect} from 'react-redux';
import {startUploadClaimsAttachments, uploadClaimsAttachments} from '../../../actions/claims/actionClaimsAttachments';
import Loader from '../../Loader';
import ValidFormattedMessage from '../../common/ValidFormattedMessage';
import PageHeader from '../../common/PageHeader';
import formTypeMessages from '../../../intl/common/formTypeMessages';
import formMessages from '../../../intl/claims/formMessages';

const UploadingClaimsAttachments = (props) => {
    const {formType, isAttachmentUploading, correlationId, attachmentsUrl, attachments} = props;

    const uploadAttachments = () => {
        const merge = [];
        attachmentsUrl.forEach(attachment => {
            const data = attachments.find(att => att.uuid === attachment.uuid);
            merge.push({
                ...attachment,
                ...data,
            })
        });
        props.uploadClaimsAttachments(merge, correlationId);
    };

    if (!isAttachmentUploading) {
        props.startUploadClaimsAttachments();
        uploadAttachments();
    }
    return (
        <div className="container-fluid">
            <PageHeader title={<ValidFormattedMessage message={formType} intlMessages={formTypeMessages}/>}/>
            <div className="container-fluid">
                <div className="col-12">
                    <FormattedMessage {...formMessages.UPLOADING_ATTACHMENTS}/>
                </div>
                <Loader/>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => state;

export default connect(mapStateToProps, {
    startUploadClaimsAttachments,
    uploadClaimsAttachments,
})(UploadingClaimsAttachments);

